export const Endpoints = {
    Activity: {
        GetAll: '/api/v1/activity/',
        Create: '/api/study/activity/session/create/',
        CriteriaEvaluation: '/api/v1/activity/criteria/evaluate/',
        SubmitSurvey: '/api/study/survey/session/response/submit/',
    },
    Auth: {
        Token: '/api/v1/auth/token/',
    },
    Chat: {
        Rooms: '/api/v1/chat/rooms/',
    },
    CustomResearcherPages: {
        Root: '/api/v1/custom_researcher_page/',
    },
    DataSource: {
        Root: '/api/v1/data_source/',
        Options: '/api/v1/data_source/options/',
    },
    Engagement: {
        AllOptions: '/api/v1/engagements/engagement-options/',
        AvailableOptions: '/api/v1/engagements/options/',
        Delete: '/api/v1/engagements/delete/',
        UploadImage: '/api/v1/engagements/upload/',
    },
    Participation: '/api/v1/participation/',
    ParticipantHistoryReport: '/api/study/ph/create/',
    AuditTrailEvent: '/api/v1/audit/',
    ProgressReward: {
        Root: '/api/v1/progress_reward/',
        Create: '/api/v1/progress_reward/',
        Overview: '/api/v1/progress_reward/progress/',
    },
    StudyRegistration: {
        Read: '/api/study/registration/',
        Join: '/api/study/registration/create/',
    },
    Study: {
        Info: '/api/study/info/register/',
        Quit: '/api/study/quit/',
    },
    User: {
        Root: '/api/v1/user/',
        DataSourceAccessStatus: '/api/study/user/cds/access/status/',
        GrantDataSourceAccess: '/api/study/user/cds/access/grant/',
        RevokeDataSourceAccess: '/api/study/user/cds/access/revoke/',
        Avatar: '/api/v1/user/avatar/',
        Email: '/api/v1/user/email/',
        Password: '/api/v1/user/password/',
        Phone: '/api/v1/user/phone/',
    },
    Registration: {
        ResetParticipationByParticipant: '/api/v1/registration/reset_participation_by_participant/',
        ResetParticipationByResearcher: '/api/v1/registration/reset_participation_by_researcher/',
    },
    Sales: {
        AllLicenses: '/api/v1/sales/contract/mine/summary/',
        PurchaseLicense: '/api/v1/sales/contract/purchase/',
        LicenseDetails: (contractId: number) => `/api/v1/sales/contract/${contractId}/details/`,
        AddLicenseManager: (contractId: number) => `/api/v1/sales/contract/${contractId}/add_license_manager/`,
        AddQuota: (contractId: number) => `/api/v1/sales/contract/${contractId}/extend_quota/`,
        ExtendValidity: (contractId: number) => `/api/v1/sales/contract/${contractId}/extend_validity/`,
        TopUpPaygCredit: (contractId: number) => `/api/v1/sales/contract/${contractId}/top_up_payg_credit/`,
        EstimateValidityExtension: (contractId: number) => `/api/v1/sales/contract/${contractId}/estimate_validity_extension/`,
        EstimateQuotaExtension: (contractId: number) => `/api/v1/sales/contract/${contractId}/estimate_quota_extension/`,
        AddStudyToLicense: (contractId: number) => `/api/v1/sales/contract/${contractId}/add_study/`,
        StudyLicenseInfo: (studyId: number) => `/api/v1/sales/study/${studyId}/contract_info/`,
        PricingPlans: '/api/v1/sales/contract/pricing_plans/',
        // BookSession: `/api/v1/sales/book_session/`,,
        BookSession: '/api/sales/person/book_demo/',
    },
    AiCohort: {
        // Cohorts
        GetCohorts: '/api/v1/virtual_cohort/cohorts/',
        GeneratePreview: '/api/v1/virtual_cohort/cohorts/preview/',
        CreateCohort: '/api/v1/virtual_cohort/cohorts/',
        GetCohortDetails: (cohortId: number) => `/api/v1/virtual_cohort/cohorts/${cohortId}/`,
        DeleteCohort: (cohortId: number) => `/api/v1/virtual_cohort/cohorts/${cohortId}/`,
        GetCohortPersonas: (cohortId: number, page = 1) => `/api/v1/virtual_cohort/cohorts/${cohortId}/personas/?page=${page}`,
        ExportPersonas: (cohortId: number) => `/api/v1/virtual_cohort/cohorts/${cohortId}/export/`,
        // Simulations
        GetSimulations: '/api/v1/virtual_cohort/simulations/',
        CreateAndRunSimulation: '/api/v1/virtual_cohort/simulations/',
        GetSimulationDetails: (simulationId: number) => `/api/v1/virtual_cohort/simulations/${simulationId}/`,
        CancelSimulation: (simulationId: number) => `/api/v1/virtual_cohort/simulations/${simulationId}/`,
        ExportSimulation: (simulationId: number) => `/api/v1/virtual_cohort/simulations/${simulationId}/export/`,
        GetSimulationPersonas: (simulationId: number) => `/api/v1/virtual_cohort/simulations/${simulationId}/personas/`,
        GetSimulationPersona: (simulationId: number, personaId: number) =>
            `/api/v1/virtual_cohort/simulations/${simulationId}/personas/${personaId}/state/`,
    },
    SqlAgent: {
        Chat: '/api/sql-agent/chat',
    },
    Appointment: {
        // All CRUD share this path; study_id and ssid go in the query string.
        Types: '/api/v1/appointment/type/',
    },
    Scheduling: {
        // study_id (and ssid/appointment_id) travel in the query string.
        Appointments: {
            List: () => `/api/v1/appointment/`,
            Book: () => `/api/v1/appointment/booking/`,
            Cancel: () => `/api/v1/appointment/booking/`,
        },
    },
    AuditTrailV2: {
        Rhr: '/api/v1/audit_trail_v2/rhr/',
    },
    InterParticipantPermissions: {
        Rules: '/api/v1/inter_participant_permission/',
        Effective: '/api/v1/inter_participant_permission/effective/',
    },
    Datasets: {
        Roots: '/api/v1/datasets/',
        Spec: (root: string) => `/api/v1/datasets/${root}/`,
        Searches: (root: string) => `/api/v1/datasets/${root}/searches/`,
        Page: (root: string, cursor: string) => `/api/v1/datasets/${root}/searches/${cursor}/`,
        Drilldowns: '/api/v1/datasets/drilldowns/',
        Exports: (root: string) => `/api/v1/datasets/${root}/exports/`,
        Filters: '/api/v1/datasets/filters/',
        Filter: (filterId: string) => `/api/v1/datasets/filters/${filterId}/`,
    },
};
